"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlackMentions = exports.SlackChannelWebhook = exports.SlackChannel = void 0;
var SlackChannel;
(function (SlackChannel) {
    SlackChannel["Cron"] = "cron";
    SlackChannel["Backend"] = "backend";
    SlackChannel["OrdersNotifications"] = "orders_notifications";
    SlackChannel["Payments"] = "payments";
    SlackChannel["General"] = "general";
    SlackChannel["BizDevTARegistration"] = "bizdev-taregistration";
    SlackChannel["PoolOrders"] = "pool_orders";
    SlackChannel["DriverOffers"] = "driver_offers";
    SlackChannel["OverbookingAlert"] = "overbooking_alert";
    SlackChannel["CustomersInteraction"] = "customers_interaction";
    SlackChannel["TestWebhook"] = "test-webhook";
    SlackChannel["DriversOperations"] = "drivers_operations";
    SlackChannel["EmailSendingFailures"] = "email-sending-failures";
    SlackChannel["VipBookings"] = "vip-bookings";
    SlackChannel["B2BMonitoring"] = "b2b_monitoring";
    SlackChannel["DriverTripCancellationMonitoring"] = "driver_trip_cancellation_monitoring";
    SlackChannel["AutomaticPenaltiesMonitoring"] = "automatic_penalties_monitoring";
    SlackChannel["TrackingMonitoringNotification"] = "tracking-monitoring-notification";
    SlackChannel["Subsidies"] = "subsidies";
})(SlackChannel || (exports.SlackChannel = SlackChannel = {}));
const slackWebhookBaseUrl = "https://hooks.slack.com/services/T0953LNUW";
exports.SlackChannelWebhook = new Map([
    [SlackChannel.Cron, `${slackWebhookBaseUrl}/B074YSQS5V1/G8ccItdA1FFSEJEv6WqT3Oj6`],
    [SlackChannel.Backend, `${slackWebhookBaseUrl}/B04HM022BK2/JgecEp5l6svS4EBjMovPUWdE`],
    [SlackChannel.EmailSendingFailures, `${slackWebhookBaseUrl}/B06T02ZV1FU/lceMz2wdCQkWbzeF7zAlWced`],
    [SlackChannel.DriversOperations, `${slackWebhookBaseUrl}/B06B5FEGJUT/Q3R7dZjdM24kRC2lFWxh1u8c`],
    [SlackChannel.OrdersNotifications, `${slackWebhookBaseUrl}/B04GXKT8HQA/jlZmIggXuANZ7cbezNSaZRFQ`],
    [SlackChannel.Payments, `${slackWebhookBaseUrl}/B04GQLYE27Q/GwhGIiWN7zcpLoY789fHYRIt`],
    [SlackChannel.General, `${slackWebhookBaseUrl}/B04GH3WRQNB/DInj75u3l8tCXNvKqLyKuBNp`],
    [SlackChannel.BizDevTARegistration, `${slackWebhookBaseUrl}/B04H03WEJ84/1NgLcvvvslGl2WiOPj5c22mt`],
    [SlackChannel.PoolOrders, `${slackWebhookBaseUrl}/B04GXKXLJM8/hmbFzyYoR3Aed7P4OISho5Ks`],
    [SlackChannel.DriverOffers, `${slackWebhookBaseUrl}/B04GR2CANQN/NsMgQ3Io1PVE0VJLl03SJJru`],
    [SlackChannel.OverbookingAlert, `${slackWebhookBaseUrl}/B04UH7FK4J3/79Q0HmeqlxDqx6m6ClohyXyN`],
    [SlackChannel.CustomersInteraction, `${slackWebhookBaseUrl}/B05JMJWJ62X/16HvvJ2dVMLs0v64kYr4aNWy`],
    [SlackChannel.VipBookings, `${slackWebhookBaseUrl}/B06VCRB1X4Y/Yjz2yAO7AxVJtuBxa49UB30B`],
    [SlackChannel.TestWebhook, `${slackWebhookBaseUrl}/B04H163D9DW/h2INplCmYEjEHOiWjQG1adjs`],
    [SlackChannel.B2BMonitoring, `${slackWebhookBaseUrl}/B088SUP6EEL/RYrRT1pwmGWAR5FwWvtqOvm6`],
    [SlackChannel.DriverTripCancellationMonitoring, `${slackWebhookBaseUrl}/B09A09H9L15/uPmiO1lLRZqvIkq7AcKaV9Iz`],
    [SlackChannel.AutomaticPenaltiesMonitoring, `${slackWebhookBaseUrl}/B09A6LHAUUB/tZY8KLGwPBxbQIu3VV4VfGfh`],
    [SlackChannel.TrackingMonitoringNotification, `${slackWebhookBaseUrl}/B0A0BH5N8L9/vy9Q7JqS7aXWtPl9heAP2fww`],
    [SlackChannel.Subsidies, `${slackWebhookBaseUrl}/B09SVLQ1KTQ/hAMSJCjbNrb2MgiikVBXIAPO`],
]);
var SlackMentions;
(function (SlackMentions) {
    SlackMentions["Loany"] = "<@UACE2RG3Z>";
    SlackMentions["Jenda"] = "<@U03FXLBM6CT>";
    SlackMentions["Sara"] = "<@U025NGFE4FM>";
    SlackMentions["SeniorOperators"] = "<!subteam^S03S1HZU0BF>";
    SlackMentions["Kris"] = "<@U04DCRNB8L8>";
    SlackMentions["TomTurek"] = "<@U0953A1HN>";
    SlackMentions["JiriSvacek"] = "<@U095BHE2U>";
    SlackMentions["HonzaProkop"] = "<@U05GS6DKCNB>";
})(SlackMentions || (exports.SlackMentions = SlackMentions = {}));
//# sourceMappingURL=SlackChannel.js.map